import React from "react";
import { Box } from "@mui/material";

export default function Footer() {
  return (
    <div className="intro">
      <h2>
        <a>
          {" 声明 "}
          <small>Statement</small>
        </a>
      </h2>
      <Box className="relaResearch">
        <p>
          本网站所展示的宏观经济预测结果及相关可视化内容，基于公开发布的统计数据和模型算法进行动态更新与呈现。
          尽管研究团队已最大程度地确保数据处理和模型运行的严谨性，手动处理与模型假设的局限性可能仍带来部分误差与滞后。
          本平台提供的信息仅供学术研究和公共参考之用，不代表任何机构立场或政策导向，亦不构成投资、政策或商业决策建议。
          使用本网站信息所造成的任何直接或间接后果，北京大学汇丰商学院不承担法律责任。
          <br /> <br />
          本网站内容（包括但不限于文本、图表、模型与样式设计）之版权归北京大学汇丰商学院及相关内容提供方所有。
          未经书面授权，任何个人或机构不得擅自复制、传播、转载、改作或用于商业用途。
          <br /> <br />
          若您对我们的模型与方法有改进意见，欢迎将意见与建议发送至：
          thinktank@phbs.pku.edu.cn。我们感谢您对 "PHBS Macroeconomic
          Nowcasting" 研究平台的关注与支持。
        </p>
      </Box>
    </div>
  );
}
